module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0015.jpg?v=8a7a10a7";